<template>
    <div class="applymobile">
        <top_mobile></top_mobile>
        <div class="formfather">
            <div class="formbox">
                <div class="formboxfont">
                    <p> 欢迎3PL物流商加入IDA云物流</p>
                    <span v-if="$route.query.vip_type==1" style="color:#00aec2;">基础版</span>
                    <span v-if="$route.query.vip_type==2" style="color:#84c024;">专业版</span>
                    <span v-if="$route.query.vip_type==3" style="color:#2693cb;">高级版</span>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                    <div class="unit">
                        <div class="units">
                            <p>手机号</p>
                        </div>
                        <el-form-item prop="phone">
                            <el-input v-model="ruleForm.phone" style="width: 20rem;" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                    </div>
                    <div class="unit">
                        <div class="units">
                            <p>验证码</p>
                        </div>
                        <el-form-item prop="code">
                            <div class="codestyle">
                                <el-input v-model="ruleForm.code" placeholder="请输入验证码" style="width: 12rem;"></el-input>
                                <div v-show="shows==true" class="codestyles" @click="keyCodes()">
                                    获取验证码
                                </div>
                                <div v-show="shows==false" class="codestyles">
                                    {{count}}秒
                                </div>
                            </div>

                        </el-form-item>
                    </div>
                    <div class="unit">
                        <div class="units">
                            <p>企业名称</p>
                        </div>
                        <el-form-item prop="company_name">
                            <el-input v-model="ruleForm.company_name" placeholder="请输入企业名称"
                                      style="width: 20rem"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item>
                        <div class="subs" @click="submitForm('ruleForm')">提交</div>
                    </el-form-item>
                    <el-form-item>
                        <div class="bots">
                            <div class="bots1">
                                <div class="bots1font" @click="bots1showclick(1)">我是货主</div>
                            </div>
                            <div class="bots2" style="cursor: auto;margin: 0 5px;">|</div>
                            <div class="bots3">
                                <div class="bots3font" @click="bots1showclick(2)">我是车主</div>
                            </div>
                        </div>

                    </el-form-item>
                </el-form>
                <div class="fixedfont">
                    <p>已注册完成，请使用下方地址，在PC端登录。</p>
                    <span @click="jump()">http://idalc.com/web</span>
                </div>

            </div>
        </div>


        <botmob></botmob>
        <van-popup v-model="bots1show" position="bottom"
                   closeable :style="{ height: '200px',background:'#efefef' }">
            <div class="bottoms">
                <div class="bottoms1" @click="showimg(1)">
                    <img src="../../public/statics/img/mobile/andriod.png" alt="">
                    <p>安卓端</p>
                </div>
                <div class="bottoms1" @click="showimg(2)">
                    <img src="../../public/statics/img/mobile/ios.png" alt="">
                    <p>IOS端</p>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="bots2show" closeable>
            <div class="czimg">
                <img v-if="type==1&&imgtype==1" src="../../public/statics/img/yhz_android.jpg" alt=""
                     @touchstart.prevent="showDeleteButton('http://img.idalc.com/andriod/dsgoods.apk')">
                <img v-if="type==1&&imgtype==2" src="../../public/statics/img/yhz_ios.png" alt=""
                     @touchstart.prevent="showDeleteButton('https://apps.apple.com/cn/app/%E4%BA%91%E8%B4%A7%E4%B8%BB/id1540908637')">
                <img v-if="type==2&&imgtype==1" src="../../public/statics/img/ywl_android.jpg" alt=""
                     @touchstart.prevent="showDeleteButton('http://img.idalc.com/andriod/supplier.apk')">
                <img v-if="type==2&&imgtype==2" src="../../public/statics/img/ywl_ios.png" alt=""
                     @touchstart.prevent="showDeleteButton('https://apps.apple.com/cn/app/%E4%BA%91%E7%89%A9%E6%B5%81%E5%95%86/id1540907919')">
                <p>长按识别下载</p>
            </div>
        </van-popup>
    </div>

</template>

<script>
    const TIME_COUNT = 60;
    import {auth, anth} from '../request/api';
    import top_mobile from "../components/top_mobile";
    import botmob from "../components/botmobile";

    export default {
        name: "apply_mobile",
        data() {
            return {

                ruleForm: {
                    phone: "",
                    code: "",
                    company_name: "",
                },
                rules: {
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'},
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                    ],
                    company_name: [
                        {required: true, message: '请输入公司名称', trigger: 'blur'},
                    ],
                },

                shows: true,  // 初始启用按钮
                count: '',   // 初始化次数
                timer: '',

                //弹框
                dialogVisible: false,


                bots1show: false,
                type: "",//1货主 2车主
                imgtype: "",//1安卓 2 ios
                bots2show: false,

                loop: null,
            }
        },
        components: {
            top_mobile, botmob
        },
        mounted() {
        },
        methods: {
            liveweb() {
                this.dialogVisible = false;
            },


            bots1showclick(e) {
                this.bots1show = true;
                this.type = e;

            },
            showimg(e) {
                this.imgtype = e;
                this.bots2show = true;
            },
            bots3showclick() {
                this.bots3show = !this.bots3show;
                this.bots1show = false;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let url = "/v1/member/login/register";
                        let data = {
                            phone: this.ruleForm.phone,
                            code: this.ruleForm.code,
                            company_name: this.ruleForm.company_name,
                            vip_type: this.$route.query.vip_type,
                        };
                        auth(url, data).then(res => {
                            if (res.data.code == 1) {
                                this.$toast.success('注册成功！');
                            } else {
                                this.$toast.fail(res.data.msg);
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 验证码
            keyCodes() {
                if (this.ruleForm.phone == undefined || this.ruleForm.phone == '') {
                    this.$toast.fail('请输入手机号');
                } else {
                    if (!this.timer) {
                        let url = "/v1/member/login/send_sms";
                        let data = {
                            phone: this.ruleForm.phone,
                            type: 2
                        };
                        auth(url, data).then(data => {
                                if (data.data.code == 1) {
                                    this.$toast.success('发送成功');
                                    this.count = TIME_COUNT;
                                    this.shows = false;
                                    this.timer = setInterval(() => {
                                        if (this.count > 0 && this.count <= TIME_COUNT) {
                                            this.count--;
                                        } else {
                                            this.shows = true;
                                            clearInterval(this.timer);  // 清除定时器
                                            this.timer = null;
                                        }
                                    }, 1000)
                                } else {
                                    this.$toast.fail(data.data.msg);
                                }
                            }
                        )
                    }
                }
            },

            //长按

            showDeleteButton(e) {
                clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
                this.Loop = setTimeout(function () {
                    // console.log(e);
                    window.location.replace(e);
                }.bind(this), 1000);
            },
            jump() {
                window.location.replace(window.idomain);
            },

        },
    }
</script>

<style scoped lang='scss'>
    .applymobile {
        width: 100%;
        height: 100%;
        position: relative;
        /*background: #666666;*/
        background: url("../../public/statics/img/mobile/beijin.png") no-repeat center center;
        background-size: auto 100%;

        .formfather {
            position: absolute;
            top: 88px;
            box-sizing: border-box;
            width: 24rem;
            height: calc(100% - 140px);
            overflow: scroll;

            .formbox {

                position: absolute;
                left: 0;
                width: 24rem;
                /*top: 88px;*/
                /*padding: 80px;*/
                box-sizing: border-box;
                height: auto;
                /*
                            max-height: calc(100% - 50px);*/
                overflow: scroll;
                display: flex;
                flex-direction: column;
                align-items: center;

                justify-content: center;


                .formboxfont {
                    color: #ffffff;
                    font-family: "PingFang SC";
                    font-size: 20px;
                    margin-bottom: 20px;
                    display: flex;
                    flex-direction: column;

                    p {
                        margin-bottom: 10px;
                    }
                }

                .unit {
                    width: 20rem;
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    flex-direction: column;
                    color: #ffffff;

                    .units {
                        display: flex;
                        align-items: center;
                        margin-bottom: 5px;

                        span {
                            color: #F35959;
                            margin-right: 5px;
                            line-height: 16px;
                            font-size: 16px;
                        }
                    }

                    .codestyle {
                        width: 19rem;
                        display: flex;
                        justify-content: space-between;

                        .codestyles {
                            width: 6rem;
                            height: 40px;
                            line-height: 40px;
                            background: linear-gradient(to bottom right, #4f8aff, #4b60ff);
                            box-shadow: 0px 5px 6px 0px rgba(4, 0, 0, 0.26);
                            border-radius: 6px;
                            cursor: pointer;
                            color: #ffffff;
                        }
                    }


                }

                .subs {
                    width: 20rem;
                    height: 40px;
                    line-height: 40px;
                    background: linear-gradient(to bottom right, #4f8aff, #4b60ff);
                    box-shadow: 0px 5px 6px 0px rgba(4, 0, 0, 0.26);
                    border-radius: 6px;
                    cursor: pointer;
                    color: #ffffff;
                }

                .bots {
                    display: flex;
                    justify-content: flex-end;
                    color: #ffffff;
                    align-items: center;
                }

                .fixedfont {
                    width: 24rem;
                    color: #fff;
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 5px;

                    span {
                        line-height: 20px;
                    }
                }

            }

        }


        .bottoms {
            height: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;

            .bottoms1 {
                display: flex;
                flex-direction: column;
                font-size: 16px;

                img {
                    width: 80px;
                    height: auto;
                    margin-bottom: 20px;
                }
            }
        }

        .czimg {
            height: auto;
            padding: 2rem;
            border-radius: 4px;

            img {
                width: 18rem;
                height: 18rem;
            }

            p {
                line-height: 2rem;
                font-size: 16px;
                text-align: center;
                font-family: "PingFang SC";
            }
        }


    }
</style>
